import React from 'react';
import propTypes from 'prop-types';
import { isEmpty as _isEmpty } from 'lodash';

import TextCell from 'app/components/data-table/TextCell';

const V = 'v';

export default function StarterKitVersion({ starterkitVersion }) {
  if (starterkitVersion === '0' || _isEmpty(starterkitVersion)) {
    return <TextCell variant="body2" />;
  }

  const versionText = starterkitVersion.startsWith(V) ? starterkitVersion : `${V}${starterkitVersion}`;

  return <TextCell variant="body2" text={versionText} />;
}

StarterKitVersion.propTypes = {
  starterkitVersion: propTypes.string,
};
